import { regionOptions, yearOptions, type FilterState, type SortKey } from "@/utils/catalog";

interface FilterSidebarProps {
  filter: FilterState;
  onChange: (next: FilterState) => void;
  onReset: () => void;
}

const sortOptions: { key: SortKey; label: string }[] = [
  { key: "hot", label: "热门" },
  { key: "new", label: "发布时间" },
];

function PillGroup({
  title,
  options,
  value,
  onSelect,
}: {
  title: string;
  options: string[];
  value: string;
  onSelect: (v: string) => void;
}) {
  return (
    <div className="mb-6 last:mb-0">
      <h3 className="text-sm font-semibold text-foreground-800 mb-3">{title}</h3>
      <div className="flex flex-wrap gap-2">
        {options.map((opt) => (
          <button
            key={opt}
            onClick={() => onSelect(opt)}
            className={`px-3 py-1.5 rounded-md text-sm transition-colors cursor-pointer whitespace-nowrap ${
              value === opt
                ? "bg-primary-500 text-background-50"
                : "bg-background-100 text-foreground-600 hover:bg-background-200 border border-background-200"
            }`}
          >
            {opt}
          </button>
        ))}
      </div>
    </div>
  );
}

export default function FilterSidebar({ filter, onChange, onReset }: FilterSidebarProps) {
  return (
    <aside className="rounded-lg border border-background-200 bg-background-50 p-5">
      <div className="flex items-center justify-between mb-5">
        <h2 className="text-base font-bold text-foreground-950 flex items-center gap-2">
          <i className="ri-filter-3-line text-primary-500"></i>
          筛选
        </h2>
        <button
          onClick={onReset}
          className="flex items-center gap-1 text-xs text-foreground-500 hover:text-primary-600 transition-colors cursor-pointer whitespace-nowrap"
        >
          <i className="ri-refresh-line"></i>
          重置
        </button>
      </div>

      <PillGroup
        title="地区"
        options={regionOptions}
        value={filter.region}
        onSelect={(v) => onChange({ ...filter, region: v })}
      />
      <PillGroup
        title="年份"
        options={yearOptions}
        value={filter.year}
        onSelect={(v) => onChange({ ...filter, year: v })}
      />

      <div>
        <h3 className="text-sm font-semibold text-foreground-800 mb-3">排序</h3>
        <div className="flex flex-wrap gap-2">
          {sortOptions.map((opt) => (
            <button
              key={opt.key}
              onClick={() => onChange({ ...filter, sort: opt.key })}
              className={`px-3 py-1.5 rounded-md text-sm transition-colors cursor-pointer whitespace-nowrap ${
                filter.sort === opt.key
                  ? "bg-primary-500 text-background-50"
                  : "bg-background-100 text-foreground-600 hover:bg-background-200 border border-background-200"
              }`}
            >
              {opt.label}
            </button>
          ))}
        </div>
      </div>
    </aside>
  );
}